import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ROUTES } from '@core/constants';
import { HttpService } from '@core/services';
import { CommonValidators } from '@core/validators';

@Component({
  selector: 'app-cp-autocomplete',
  imports: [FormsModule, ReactiveFormsModule],
  template: ``,
  styles: [``],
})
export class CpAutocompleteComponent {
  ROUTES = ROUTES;
  _httpService = inject(HttpService);

  form = new FormGroup({
    userNotRequired: new FormControl(null),
    user: new FormControl(null, [CommonValidators.required]),
    exchangeRate: new FormControl(null, [CommonValidators.required]),
    bankId: new FormControl(null, [CommonValidators.required]),
  });
}
